import $ from 'jquery';
import _ from 'underscore';
import StateManager from './StateManager';

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find('.js-scuba__list:has(.js-scuba__list__form)').each(function(i, list) {
        new Scuba_ListForm(list);
    });
});


/* --------------------------------------------------

    CLASS

-------------------------------------------------- */

function Scuba_ListForm() {
    // console.log('new Scuba_ListForm()');
    this.initialize.apply(this, arguments);
}

$.extend(Scuba_ListForm.prototype, {

    initialize: function(list) {
        this.uid = _.uniqueId('scuba-');
        this.$list = $(list);
        this.$page = this.$list.closest('.js-scuba__page, .js-scuba__head');
        this.$page.on('scuba:dispose', $.proxy(this.dispose, this));
        // récupération des paramètres partagés
        this.params = this.$list.data('scuba-list-params');
        if (!this.params) {
            this.$list.data('scuba-list-params', this.params = {});
        }

        // récupération des éléments
        this.$form = this.$list.find('.js-scuba__list__form');

        this.$filters = this.$list.find('.js-scuba__list__filters');

        // this.$filters = $(
        //     '<div class="dgt-list-filters">'+
        //         '<a class="toggle">Filtrer</a>'+
        //         '<div class="overlay">'+
        //             '<a class="toggle">Masquer les filtres</a>'+
        //         '</div>'+
        //     '</div>'
        // );
        this.$list.find('.js-scuba__list__filters').replaceWith(this.$filters);
        this.$filtersOverlay = this.$filters.find('.js-scuba__list__filters__overlay');

        this.$filtersToggle = this.$filters.find('.js-scuba__list__filters__toggle');
        this.$itemsWrap = this.$list.find('.js-scuba__list__items');

        // config
        this.isFormOnLeft = !this.$form.closest('.js-scuba__list__filters').length;
        this.defaultFormPosition = this.isFormOnLeft ? 'left' : 'filters';
        this.$list.toggleClass('has-form-left', this.isFormOnLeft);

        // écouteurs
        this.$filtersToggle.on('click', $.proxy(this.toggleOverlay, this));
        this.$filtersOverlay.on('click', $.proxy(this.toggleOverlay, this));
        this.$form.on('click', e => e.stopPropagation());
        this.$filtersToggle.on('click', e => e.stopPropagation());
        this.$form.on('submit', $.proxy(this.form_submitHandler, this));
        if ( this.$list.hasClass('has-form-left') ){
          this.$form.on('change', ':radio,:checkbox,input[type=text],select,input[type=number]', $.proxy(this.form_submitHandler, this));
        }

        // écouteur layout
        var $body = $(document.body);
        $body.on('layout:change.'+this.uid, $.proxy(this.invalidateLayout, this));
        this.invalidateLayout(null, $body.data('layout'));

        // init
        this.list = this.$list.data('js-scuba__list');
        if (this.list){
          this.listReady();
        }
        else{
          this.$list.on('scuba-list', $.proxy(this.listReady, this));
        }
    },

    listReady: function() {
        this.list = this.$list.data('js-scuba__list');
        this.$form.trigger('submit');
    },

    dispose: function() {
        var namespace = '.' + this.uid;
        $(document.body).off(namespace);
    },

    invalidateLayout: function(event, layout) {
        if (!layout) return;
        this.isMobile = layout === 'MobileLayout';
        this.invalidatePosition();
    },

    invalidatePosition: function() {
        // console.log('Scuba_ListForm.invalidatePosition()');
        if (this.defaultFormPosition == 'left') {
            var isFormOnLeft = !this.isMobile;
            if (isFormOnLeft === this.isFormOnLeft) return;

            this.isFormOnLeft = isFormOnLeft;
            if (this.isFormOnLeft) {
                this.$form.prependTo(this.$list);
                this.$list.addClass('has-form-left');
            } else {
                this.$form.appendTo(this.$filtersOverlay);
                this.$list.removeClass('has-form-left');
            }
        }
    },

    toggleOverlay: function(event) {
        event && event.preventDefault();

        this.$filters.toggleClass('is-opened');
    },

    form_submitHandler: function(event) {
        event.preventDefault();

        this.jqXHR && this.jqXHR.abort();

        this.jqXHR = $.ajax({
            type: 'get',
            url: this.$form.attr('action'),
            data: this.$form.serialize(),
            dataType: 'json',
            context: this,
        });

        this.jqXHR.done(this.jqXHR_doneHandler);
        this.jqXHR.fail(this.jqXHR_failHandler);
        this.jqXHR.always(this.jqXHR_alwaysHandler);
    },

    jqXHR_doneHandler: function(data/*, textStatus, jqXHR*/) {
        this.list.parseItems(data.html, true);
        this.$list.trigger('scuba:listform:refresh', [ data ]);
        this.$filters.removeClass('is-opened');
    },

    jqXHR_failHandler: function(/*jqXHR, textStatus, errorThrown*/) {
    },

    jqXHR_alwaysHandler: function() {
        this.jqXHR = null;
    },

});



// WEBPACK FOOTER //
// ./scripts/scuba/ListForm.js